import { apiClient } from "./api-client";
import type {
  NotificationPage,
  NotificationReadAllResult,
  NotificationReadResult,
} from "../types/notification";

interface ApiResponse<T> {
  data: T;
}

export function getNotifications(before?: string): Promise<NotificationPage> {
  const query = new URLSearchParams({ limit: "20" });
  if (before) query.set("before", before);
  return apiClient
    .get<ApiResponse<NotificationPage>>(`/notifications?${query}`)
    .then((response) => response.data);
}

export function markNotificationRead(id: string): Promise<NotificationReadResult> {
  return apiClient
    .patch<ApiResponse<NotificationReadResult>>(`/notifications/${id}/read`, undefined)
    .then((response) => response.data);
}

export function markAllNotificationsRead(): Promise<NotificationReadAllResult> {
  return apiClient
    .post<ApiResponse<NotificationReadAllResult>>("/notifications/read-all")
    .then((response) => response.data);
}
